'use client';
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { ArrowRight, Tag } from 'lucide-react';
import { fetchSettings } from '@/lib/supabase/dinauto-service';

export default function DiscountBanner() {
  const [discount7, setDiscount7] = useState('10');
  const [discount14, setDiscount14] = useState('15');

  useEffect(() => {
    fetchSettings()?.then((s) => {
      if (s?.['discount_7_days_percent']) setDiscount7(s?.['discount_7_days_percent']);
      if (s?.['discount_14_days_percent']) setDiscount14(s?.['discount_14_days_percent']);
    });
  }, []);

  return (
    <section className="py-16 bg-primary">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
          {/* Left */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-3">
              <Tag size={18} className="text-foreground" />
              <span className="text-foreground/70 text-xs font-bold uppercase tracking-widest">Long-term discounts</span>
            </div>
            <h2 className="font-black text-4xl leading-tight text-foreground mb-4" style={{ fontWeight: 900 }}>
              The longer you rent,<br />the more you save.
            </h2>
            <div className="flex flex-wrap gap-4">
              <div className="bg-foreground text-white px-5 py-3">
                <p className="text-2xl font-black tabular-nums" style={{ fontWeight: 900 }}>{discount7}% OFF</p>
                <p className="text-white/60 text-xs font-600 uppercase tracking-wide">7 – 13 days</p>
              </div>
              <div className="bg-foreground text-white px-5 py-3">
                <p className="text-2xl font-black tabular-nums text-primary" style={{ fontWeight: 900 }}>{discount14}% OFF</p>
                <p className="text-white/60 text-xs font-600 uppercase tracking-wide">14+ days</p>
              </div>
              <div className="bg-foreground/15 text-foreground px-5 py-3">
                <p className="text-sm font-700">Applied automatically</p>
                <p className="text-foreground/60 text-xs">No coupon code needed</p>
              </div>
            </div>
          </div>
          {/* Right CTA */}
          <div className="flex flex-col gap-3">
            <p className="text-foreground/70 text-sm leading-relaxed">
              Discount applies to the car base price. Add-ons are priced separately. Calculated live in the booking form.
            </p>
            <Link href="/reservation" className="btn-secondary gap-2 self-start">
              Book Long-term <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}